import { createSelector } from 'reselect';

export const getAttachments = createSelector(
  state => state.attachments,
  attachments => attachments
);
